import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { colors } from '../styles/shared.js';
import { t } from '../i18n.js';
import { cmdNavPrev, cmdNavNext, cmdRestartStage, cmdOpenControls, cmdSaveExit, cmdOpenTouchMenu, cmdCloseOverlays } from '../commands.js';

import './hamburger-button.js';

@customElement('touch-menu-overlay')
export class TouchMenuOverlay extends LitElement {
  static styles = [
    colors,
    css`
      :host {
        position: absolute;
        inset: 0;
        pointer-events: auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 0.8rem;
      }
      .title {
        color: var(--color-white);
        font-size: 1.6rem;
        font-weight: bold;
        margin-bottom: 0.5rem;
      }
      .menu-item {
        color: var(--color-cyan);
        font-size: 1.4rem;
        cursor: pointer;
        padding: 0.3rem 1rem;
        user-select: none;
      }
      .menu-item.disabled {
        color: var(--color-dim);
        cursor: default;
      }
    `,
  ];

  @property({ type: Boolean }) accessor canGoPrev = false;
  @property({ type: Boolean }) accessor canGoNext = false;
  @property({ type: Boolean }) accessor stageProgressed = false;

  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('click', cmdCloseOverlays);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener('click', cmdCloseOverlays);
  }

  private _stop(e: Event) {
    e.stopPropagation();
  }

  render() {
    return html`
      <hamburger-button></hamburger-button>
      <div class="title" @click=${this._stop}>${t('touch-menu-title')}</div>
      <div
        class="menu-item ${this.canGoPrev ? '' : 'disabled'}"
        @click=${(e: Event) => { e.stopPropagation(); this.canGoPrev && cmdNavPrev(); }}
      >${t('touch-menu-prev')}</div>
      <div
        class="menu-item ${this.canGoNext ? '' : 'disabled'}"
        @click=${(e: Event) => { e.stopPropagation(); this.canGoNext && cmdNavNext(); }}
      >${t('touch-menu-next')}</div>
      <div
        class="menu-item ${this.stageProgressed ? '' : 'disabled'}"
        @click=${(e: Event) => { e.stopPropagation(); this.stageProgressed && cmdRestartStage(); }}
      >${t('touch-menu-restart')}</div>
      <div class="menu-item" @click=${(e: Event) => { e.stopPropagation(); cmdOpenControls(); }}>${t('touch-menu-controls')}</div>
      <div class="menu-item" @click=${(e: Event) => { e.stopPropagation(); cmdSaveExit(); }}>${t('touch-menu-save-exit')}</div>
    `;
  }
}
